import { c as _c } from "react/compiler-runtime";
import { Badge } from '@repo/ui/primitives/Badge';
import { Typography } from '@repo/ui/Typography';
import { RewardsRateTypeToUnit } from '../../../config/constants';
export const RewardsRateRow = t0 => {
  const $ = _c(13);
  const {
    description,
    index,
    rate,
    type
  } = t0;
  const t1 = `${rate}${RewardsRateTypeToUnit[type]}`;
  const t2 = index + 1;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      px: "0",
      py: "0",
      width: "[48px]",
      height: "[23px]",
      gridColumn: 1,
      gridRow: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t3) {
    t4 = <Badge colorVariant="green2" text={t1} css={t3} />;
    $[2] = t1;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = index + 1;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      gridColumn: 2,
      gridRow: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== description || $[8] !== t6) {
    t7 = <Typography variant="text" css={t6}>{description}</Typography>;
    $[7] = description;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[10] = t4;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};